import { createSlice } from '@reduxjs/toolkit'
import { fetchAllCampaigns, fetchCampaignDetails, fetchCampaignPlayers, fetchFreeSpinUserReport } from 'redux-thunk/thunk/Promotions/promotions'

const initialState = {
  allCampaigns: null,
  campaignDetail: null,
  freeSpinUserReport: null,
  campaignPlayers: null
}

const promotionsSlice = createSlice({
  name: 'promotionsSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCampaigns.fulfilled, (state, action) => {
        return {
          ...state,
          allCampaigns: action.payload
        }
      })
      .addCase(fetchCampaignDetails.fulfilled, (state, action) => {
        return {
          ...state,
          campaignDetail: action.payload
        }
      })
      .addCase(fetchFreeSpinUserReport.fulfilled, (state, action) => {
        return {
          ...state,
          freeSpinUserReport: action.payload
        }
      })
      .addCase(fetchCampaignPlayers.fulfilled, (state, action) => {
        return {
          ...state,
          campaignPlayers: action.payload
        }
      })
  }
})

export default promotionsSlice.reducer
